
export default class Footer {
	static init() {
		const backtotop = document.querySelector('#backtotop');
		if(backtotop) {
			backtotop.addEventListener('click', () => {
				$("html, body").animate({scrollTop: 0});
				return false;
			});
		}
	}
}
